// เรียก Inbox Center ผ่าน relay ของเราเอง (/app-api/inbox/*) ไม่ยิงตรงข้ามโดเมน
//
// Inbox Center ยืนยันตัวตนด้วย JWT ใน localStorage (key `wz_session`) แล้วแนบเป็น
// Bearer header เอง — ไม่ใช้ cookie ดังนั้นหน้า parent ต้องแนบ header ให้เองด้วย
// อ่าน localStorage ของ iframe ได้เพราะ proxy ทำให้เป็น same-origin กัน
import type { Brand } from "@contracts/api";
import { api } from "@shared/api/client";

export type InboxPage = {
  id: string;
  name?: string;
  picture?: string;
  todayNewMessages?: number;
};

/** LINE OA ใน Inbox Center คือ "เพจ" ที่ id ขึ้นต้น line_ (Facebook คือที่เหลือ) */
export const isLinePage = (id: string) => String(id).startsWith("line_");

function readToken(store: Storage, key: string): string | null {
  try {
    const s = JSON.parse(store.getItem(key) ?? "null");
    return s?.access_token ?? null;
  } catch {
    return null;
  }
}

/** ลำดับ: token ของ Inbox Center เอง → token จากหน้า Staff ของเรา (Wazzup เดียวกัน) */
export function wazzupToken(): string | null {
  return readToken(localStorage, "wz_session") || readToken(localStorage, "wazzup_session");
}

export function inboxAuthHeaders(): Record<string, string> | null {
  const token = wazzupToken();
  return token ? { Authorization: "Bearer " + token } : null;
}

export const inboxKeys = {
  pages: (pageIds: string[]) => ["inbox", "pages", pageIds.join(",")] as const,
};

/** รายการเพจของแบรนด์ + จำนวนห้องที่มีข้อความวันนี้ (todayNewMessages) */
export async function fetchBrandPages(brand: Brand): Promise<InboxPage[]> {
  const headers = inboxAuthHeaders();
  if (!headers) throw new Error("ยังไม่ได้เชื่อมต่อบัญชี Wazzup");
  const ids = brand.pageIds ?? [];
  /*
   * ไม่ได้ล็อกเพจไว้ = ไม่มีเพจของแบรนด์นี้ จึงไม่ถามปลายทางเลย
   *
   * ถ้าถามโดยไม่ส่ง pageId ฝั่งเขาคืนทุกเพจที่บัญชีเข้าถึงได้ แล้วตัวเลขข้างเมนู
   * Messages จะกลายเป็นยอดของทั้งเครือ ทั้งที่กดเข้าไปก็เปิดอะไรไม่ได้
   */
  if (!ids.length) return [];
  const { data } = await api.get<InboxPage[]>("/inbox/pages", {
    headers,
    params: { pageId: ids.join(",") },
  });
  return Array.isArray(data) ? data : [];
}

export const sumToday = (pages: InboxPage[]) =>
  pages.reduce((s, p) => s + (p.todayNewMessages || 0), 0);
